import { StyleClosetTheme, Text, ThemeColor, get as themeGet } from '@betterment/style-closet-react';
import styled from '@emotion/styled';
import { Link as ReactRouterLink } from 'react-router-dom';

export interface Props extends Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'color'> {
  color?: ThemeColor;
  underline?: boolean;
  lineHeight?: number;
  isBold?: boolean;
}

const Link = styled(Text.withComponent('a'))<Props, StyleClosetTheme>`
  color: ${props => themeGet(`colors.${props.color || 'bmtBlue'}`)(props) as string} !important;
  text-decoration: ${props => (props.underline ? 'underline' : 'none')};
  &:hover {
    text-decoration: underline;
  }
  line-height: ${props => (props.lineHeight ? props.lineHeight : 'inherit')};
  font-weight: ${props => (props.isBold ? '600' : 'inherit')};
`;

export const StyledReactRouterLink = styled(Text.withComponent(ReactRouterLink))<Props, StyleClosetTheme>`
  color: ${props => themeGet(`colors.${props.color || 'bmtBlue'}`)(props) as string} !important;
  text-decoration: ${props => (props.underline ? 'underline' : 'none')};
  &:hover {
    text-decoration: underline;
  }
  line-height: ${props => (props.lineHeight ? props.lineHeight : 'inherit')};
  font-weight: ${props => (props.isBold ? '600' : 'inherit')};
`;

export default Link;
